import {createAction, props} from "@ngrx/store";
import {DeviceInterface} from "../../interfaces/device.interface";

const eventId = '[DEVICE]';

export const deviceAction = createAction(`${eventId} DEVICE CONFIG Saved`, props<DeviceInterface>());
